export default __webpack_public_path__ + "static/media/zip.c406e0dc.png";